import * as React from 'react'
import { useSearchParams } from 'react-router-dom'
import { TriangleDown } from 'src/assets/icons/customIcons/TriangleDown'
import { TriangleUp } from 'src/assets/icons/customIcons/TriangleUp'

interface SortButtonsProps {
  readonly sortField: string
}

export function SortButtons({ sortField }: SortButtonsProps): JSX.Element {
  const [searchParams, setSearchParams] = useSearchParams()
  const sortBy = searchParams.get('sortBy')

  const handleSortChange = React.useCallback(
    (sortValue: string | null) => {
      setSearchParams((prev) => {
        if (sortValue == null) {
          prev.delete('sortBy')
        } else {
          prev.set('sortBy', sortValue)
        }
        return prev
      })
    },
    [setSearchParams]
  )

  const handleAscClick = React.useCallback(() => {
    const ascValue = `${sortField}:asc`
    if (sortBy === ascValue) {
      handleSortChange(null)
    } else {
      handleSortChange(ascValue)
    }
  }, [sortField, sortBy, handleSortChange])

  const handleDescClick = React.useCallback(() => {
    const descValue = `${sortField}:desc`
    if (sortBy === descValue) {
      handleSortChange(null)
    } else {
      handleSortChange(descValue)
    }
  }, [sortField, sortBy, handleSortChange])

  return (
    <div className="flex flex-col">
      <button onClick={handleAscClick} className="flex items-center justify-center p-0.5 text-primaryTextColor">
        <TriangleUp active={sortBy === `${sortField}:asc`} />
      </button>
      <button onClick={handleDescClick} className="flex items-center justify-center p-0.5 text-primaryTextColor">
        <TriangleDown active={sortBy === `${sortField}:desc`} />
      </button>
    </div>
  )
}
